
import {  getLocalStorageData } from '../utils/util';
import { JWTToken, TOKEN_DATA_TYPE } from '../vars';
import apiClient from './apiService';
  
  function interceptor () {
    apiClient.interceptors.request.use(
      (req) => { 
        console.log(req);
        
        if (typeof window !== "undefined" && req?.headerToken === TOKEN_DATA_TYPE.ACCESS) {
          const getJWTToken = getLocalStorageData(JWTToken);
          if (getJWTToken) {
            req.headers.Authorization = `Bearer ${getJWTToken}`;
          }        
        }
        return req;
      },
      (error) => Promise.reject(error)
    );
  
    apiClient.interceptors.response.use(
      (res) => res,
      (error) => 
        // if (error.response?.status === 403) {
        //   if (error.response.data) {
        //     error.response.data.message = '';
        //   }
        //   handleLogout?.();
          // window.location.href = window.location.origin;
        // }
         Promise.reject(error)
      
    );
  };
  
  export default interceptor;
  